import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  box-sizing: border-box;
  margin: 14px 40px;
  border: 1px solid ${(props) => props.theme.colors.cardContainerEvolutiveCross};
  border-radius: 4px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 26px;
  gap: 12px;
  background-color: ${({ theme }) => theme.colors.headerCrossListContainer};
  border-bottom: 1px solid
    ${(props) => props.theme.colors.cardContainerEvolutiveCross};
  border-radius: 4px;
  label {
    display: flex;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    max-width: 40%;
    color: ${(props) => props.theme.colors.titleEvolutiveCross};
  }
`;

export const SearchBox = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.inputSearchColor};
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  gap: 10px;
  width: 30%;
  border-radius: 4px;
  height: 36px;
  border: 1px solid transparent;
  input {
    border: none;
    outline: none;
    color: ${({ theme }) => theme.colors.titleEvolutiveCross};
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    box-shadow: none;
    width: calc(100% - 20px);
    height: 100%;
    background: none;
    ::placeholder {
      color: ${({ theme }) => theme.colors.text.placeholder};
      font-size: 14px;
    }
    :focus {
      color: ${({ theme }) => theme.colors.labelFontColorEvolutiveCross};
    }
  }
  :focus-within {
    border-color: ${({ theme }) => theme.colors.labelFontColorEvolutiveCross};
  }
`;

export const Filter = styled.div`
  display: flex;
  width: 25%;
  height: 36px;
  padding: 0px;
  flex-direction: row;
  outline: none;
  box-shadow: none;
  border: 1px solid ${({ theme }) => theme.colors.cardContainerEvolutiveCross};
  border-radius: 4px;
  position: relative;
  z-index: 1000;
  .iconContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 51px;
    border-left: 1px solid
      ${({ theme }) => theme.colors.cardContainerEvolutiveCross};
  }
  :hover {
    background-color: ${({ theme }) => theme.colors.labelEvolutiveCross};
    cursor: pointer;
    span {
      svg {
        fill: ${({ theme }) => theme.colors.iconButtonColor};
      }
    }
  }
`;

export const HandleFilter = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    :hover {
      cursor: pointer;
    }
`;

export const FilterTextContent = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: calc(100% - 51px);
  margin-left: 20px;

  &:active {
    span {
      color: ${({ theme }) => theme.colors.borderColorCollapsibleContainer};
    }
  }

  svg {
    path {
      fill: ${({ theme, hasDate }) => hasDate && theme.colors.labelFontColorEvolutiveCross};
    }
  }
`;

export const FilterText = styled.span`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme, hasDate }) => hasDate ? theme.colors.labelFontColorEvolutiveCross : theme.collapsibleList.textColor};
  margin-left: 20px;
  svg{
    margin: 0 14px;
    path {
      fill:  ${({ theme }) => theme.collapsibleList.textColor}
    }
  }
`;

export const CollapsibleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 16px 26px;
`;

export const BodyExpandContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .tooltipContainer {
    min-height: 26px;
    border: none;
    background: none;
    margin-bottom: 10px;
    h2 {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: ${({ theme }) => theme.collapsibleList.textColor};
    }
  }
`;

export const AlternativesItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${({ theme }) => theme.colors.cardContainerEvolutiveCross};
`;

export const ItemsEmpty = styled.div`
  padding: 0px 24px;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100px;
`;